import TodoReducer from "./TodoReducer";
import { combineReducers } from "redux";

const rootReducer = combineReducers({
    TodoReducer
})
export default rootReducer
// const initialState = {
//     count: 0
// }
// function rootReducer (state={initialState}, action){
//     return initialState
// }
